<template>
  <div class="index-content">
    <header-content
      class="transition"
      :class="
        carouselIndex === 0 && carouselFirstIndex === 0 ? 'first-carousel' : ''
      "
      :logoIsBlack="carouselIndex === 0 && carouselFirstIndex === 0"
    ></header-content>

    <div class="wheel" @wheel="handleWheel">
      <el-carousel
        height="100vh"
        trigger="click"
        direction="vertical"
        :autoplay="false"
        ref="carousel"
        @change="carouselChange"
      >
        <el-carousel-item>
          <carousel1-content
            :carouselFirstIndex.sync="carouselFirstIndex"
          ></carousel1-content>
        </el-carousel-item>
        <el-carousel-item>
          <carousel2-content></carousel2-content>
        </el-carousel-item>
        <el-carousel-item>
          <carousel3-content></carousel3-content>
        </el-carousel-item>
        <el-carousel-item>
          <carousel4-content></carousel4-content>
        </el-carousel-item>
        <el-carousel-item>
          <carousel5-content></carousel5-content>
        </el-carousel-item>
      </el-carousel>

      <div class="carousel-next" @click="handleNext">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
        >
          <path
            d="M7.50234 19.8781L20.0312 31.4663L32.5601 19.8781C33.327 19.3839 34.3494 19.3839 34.8607 19.8781C35.3719 20.6177 35.3719 21.6061 34.8607 22.0969L20.5391 35.1609C20.5391 35.4063 20.2834 35.4063 20.0278 35.4063C19.7722 35.4063 19.7722 35.4063 19.5166 35.1609L5.19493 22.0969C4.42806 21.3573 4.68369 20.3723 5.19493 19.8781C5.9652 19.3839 6.98769 19.3839 7.50234 19.8781Z"
            fill="#009D94"
          />
          <path
            d="M20.625 23.0969C20.625 23.3782 20.332 23.3782 20.0391 23.3782C19.7461 23.3782 19.4531 23.3782 19.4531 23.0969L3.03908 8.12427C2.16017 7.27661 2.45314 6.14771 3.03908 5.5813C3.91799 5.0188 5.08986 5.0188 5.6758 5.5813L20.0391 18.8586L34.3985 5.29614C35.2774 4.72974 36.4492 4.72974 37.0352 5.29614C37.6211 6.1438 37.6211 7.27661 37.0352 7.83911L20.625 23.0969Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <right-nav></right-nav>
  </div>
</template>

<script>
import headerContent from "@/components/header.vue";
import carousel1Content from "./index/carousel-1.vue";
import carousel2Content from "./index/carousel-2.vue";
import carousel3Content from "./index/carousel-3.vue";
import carousel4Content from "./index/carousel-4.vue";
import carousel5Content from "./index/carousel-5.vue";
import rightNav from "@/components/right-nav.vue";
export default {
  components: {
    headerContent,
    carousel1Content,
    carousel2Content,
    carousel3Content,
    carousel4Content,
    carousel5Content,
    rightNav,
  },
  data() {
    return {
      carouselIndex: 0,
      carouselFirstIndex: 0,
      carouselLoading: false,
    };
  },
  methods: {
    handleWheel(event) {
      if (this.carouselLoading) return;
      if (event.deltaY > 0) {
        this.carouselLoading = true;
        this.$refs.carousel.next();
      } else {
        this.carouselLoading = true;
        this.$refs.carousel.prev();
      }
      setTimeout(() => {
        this.carouselLoading = false;
      }, 300);
    },

    handleNext() {
      this.carouselLoading = true;
      this.$refs.carousel.next();
      setTimeout(() => {
        this.carouselLoading = false;
      }, 300);
    },
    carouselChange(index) {
      this.carouselIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.index-content {
  width: 100vw;
  height: 100vh;
  .header-content {
    background: rgba(0, 0, 0, 0.7);
    &.first-carousel {
      background: transparent;
      ::v-deep {
        .header-nav {
          .nav-item {
            color: #1b2323;
            &.active {
              color: #009d94;
              font-weight: 700;
              box-shadow: none;
            }
            &:hover {
              color: #ffffff;
            }
          }
        }
        .lang-item {
          color: #1b2323;
          &.active {
            color: #009d94;
          }
        }
      }
    }
  }

  ::v-deep {
    .el-carousel__indicators--vertical {
      left: 32px;
      width: 10px;
      .el-carousel__indicator--vertical {
        padding: 4px 0;
        .el-carousel__button {
          width: 10px;
          height: 10px;
          background-color: #ffffff;
          border-radius: 5px;
          opacity: 1;
        }
        &.is-active {
          .el-carousel__button {
            height: 20px;
            background: #009d94;
          }
        }
      }
    }
  }
  .wheel {
    position: relative;
    .carousel-next {
      position: absolute;
      bottom: 100px;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
      animation: identifier 1s infinite linear;
      cursor: pointer;
    }
  }
}
@keyframes identifier {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(10px);
  }
}
</style>
